<div class="notification-host" aria-live="polite" aria-atomic="true">
  @for (notification of notificationService.notifications(); track notification.id) {
    <article class="notification-card" [ngClass]="'notification-' + notification.severity" data-testid="notification-card">
      <div class="notification-copy">
        @if (notification.title) {
          <p class="notification-title">{{ notification.title }}</p>
        }
        <p class="notification-message">{{ notification.message }}</p>
      </div>

      <div class="notification-actions">
        @if (notification.action) {
          <button type="button" class="notification-action" (click)="notification.action.run()">
            {{ notification.action.label }}
          </button>
        }
        <button
          type="button"
          class="notification-dismiss"
          [attr.aria-label]="'notifications.dismiss' | translate"
          (click)="dismiss(notification.id)">
          ×
        </button>
      </div>
    </article>
  }
</div>
